/*------------------------------------*\
    CUSTOM SELECT
\*------------------------------------*/
class CustomSelect {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.select = self.elem.querySelector('[data-custom-select-menu-select]');
        self.isOpen = false;
        self.onOutsideClick = self.onOutsideClick.bind(self);
    }

    init() {
        let self = this;

        // Hide the default select element
        self.select.classList.add('sr-only');

        // Build the dropdown
        self.buildDropown();

        // Listen for clicks on dropdown header
        self.header.addEventListener('click', evt => {
            if(self.isOpen) {
                // Close it
                self.closeDropdown();
            } else {
                // Open it
                self.openDropdown();
            }
        });

        // Listen for clicks on custom select menu options
        [...self.options].map(option => {
            option.addEventListener('click', evt => {
                self.changeOption(option);
            });
        });

        // On page load, set the custom select menu item to match the basic select menu
        self.setOptionFromSelect();
    }

    openDropdown() {
        let self = this;

        // Set aria-expanded to true
        self.header.setAttribute('aria-expanded', true);

        // Add is-open class to dropdown
        self.optionsContainer.classList.add('is-open');

        // Set isOpen status to true
        self.isOpen = true;

        // Add event listeners
        self.addEventListeners();
    }

    closeDropdown() {
        let self = this;

        // Set aria-expanded to false
        self.header.setAttribute('aria-expanded', false);

        // Remove is-open class from dropdown
        self.optionsContainer.classList.remove('is-open');

        // Set isOpen status to false
        self.isOpen = false;

        // Remove event listeners
        self.removeEventListeners();
    }

    addEventListeners() {
        let self = this;

        // Start listening for clicks outside the dropdown
        document.addEventListener('click', self.onOutsideClick);
    }

    removeEventListeners() {
        let self = this;

        // Stop listening for clicks outside the dropdown
        document.removeEventListener('click', self.onOutsideClick);
    }

    onOutsideClick(evt) {
        let self = this;

        // Close the options if there's a click anywhere outside of the header button
        if (evt.target !== self.header && !self.header.contains(evt.target)) {
            self.closeDropdown();
        }
    }

    changeOption(option) {
        let self = this;

        // Get the index of the clicked item
        let selectedItemIndex = Array.prototype.indexOf.call(self.optionsContainer.children, option);
        
        // Select the equivelant option in the select menu
        self.select.selectedIndex = selectedItemIndex;

        // Update the text in the header
        self.headerLabel.textContent = option.textContent;
    }

    setOptionFromSelect() {
        let self = this;

        // Get the selected option
        let selectedOption = self.select.options[self.select.selectedIndex];
        
        // Update the text in the header to match
        self.headerLabel.textContent = selectedOption.text;
    }

    buildDropown() {
        let self = this;

        // Create wrapper
        let wrapper = document.createElement('div');
        wrapper.classList.add('custom-select-menu__custom');

        // Create header button
        let header = document.createElement('button');
        header.classList.add('custom-select-menu__header');
        header.setAttribute('type', 'button');
        header.setAttribute('aria-expanded', 'false');
        header.setAttribute('data-custom-select-menu-header', '');

        // Create header label
        let headerLabel = document.createElement('div');
        headerLabel.setAttribute('data-custom-select-menu-header-label', '');

        // Create header icon
        let headerIcon = document.createElement('div');
        headerIcon.classList.add('custom-select-menu__header-icon');
        headerIcon.innerHTML = '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.55 27.55"><path d="M13.77,21.72.44,8.39A1.5,1.5,0,0,1,2.56,6.27L13.77,17.48,25,6.27a1.5,1.5,0,0,1,2.12,2.12Z" style="fill:currentColor"/></svg>';

        // Create options container
        let optionsContainer = document.createElement('div');
        optionsContainer.classList.add('custom-select-menu__options');
        optionsContainer.setAttribute('data-custom-select-menu-options', '');

        // Add items to options container
        [...self.select.options].map(option => {
            let newItem = document.createElement('button');
            newItem.classList.add('custom-select-menu__option');
            newItem.setAttribute('type', 'button');
            newItem.setAttribute('data-custom-select-menu-option', '');
            newItem.textContent = option.text;

            optionsContainer.appendChild(newItem);
        });

        // Append header label and icon to header
        header.appendChild(headerLabel);
        header.appendChild(headerIcon);

        // Add header to wrapper
        wrapper.appendChild(header);

        // Add custom select menu to wrapper
        wrapper.appendChild(optionsContainer);

        // Add everything to the main element
        self.elem.appendChild(wrapper);

        // Create some class properties
        self.header = self.elem.querySelector('[data-custom-select-menu-header]');
        self.headerLabel = self.elem.querySelector('[data-custom-select-menu-header-label]');
        self.optionsContainer = self.elem.querySelector('[data-custom-select-menu-options]');
        self.options = self.elem.querySelectorAll('[data-custom-select-menu-option]');
    }
}

export default CustomSelect;
